const Sentry = require('@sentry/browser');

export const initSentry = () => {
    Sentry.init({
        dsn: process.env.SENTRY_DSN_FRONTEND,
        integrations: [Sentry.browserTracingIntegration()],
        tracePropagationTargets: [/^https:\/\/factory\.dev/],
        tracesSampleRate: 0.1,
        profilesSampleRate: 0.1,
        environment: 'prod',
    })
}
